<article class="container">
    <section class="filters">
        <app-opportunities-filters [filtersKey]="filtersKey"></app-opportunities-filters>
        <button type="button" class="secondary-btn newOpportunityButton" (click)="onNewOpportunityClicked()">
            + New Opportunity
        </button>
    </section>
    <section class="grid">
        <app-opportunities-list [filtersKey]="filtersKey" [buildingId]="buildingId()"></app-opportunities-list>
    </section>
</article>
